<template>
  <div class="map" id="mapBox">
    
  </div>
  <el-dialog
    v-model="dialogVisible"
    :title="info.title"
    width="1200px"

  >
    <div v-html="info.content"></div>

  </el-dialog>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { reactive, toRefs, onMounted } from "vue"
import { api } from "@/api"
import { ElNotification } from 'element-plus'
export default {
  name: "map1",
  setup() {
    let initData = reactive({
      map: "",
      listData: "",
      initMarker: [106.142974, 30.795282],
      loading: false,
      info: "",
      dialogVisible: false,
    })
    onMounted(() => {
      initMap()
    })
    // 初始化地图组件
    function initMap() {
      AMapLoader.load({
        key: "51ba2a273d95eb7395769d94a1e4060c", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        AMapUI: {
          // 是否加载 AMapUI，缺省不加载
          version: "1.1", // AMapUI 缺省 1.1
          plugins: [], // 需要加载的 AMapUI ui插件
        },
       
      })
        .then((AMap) => {
          initData.map = new AMap.Map("mapBox", {
            resizeEnable: true,
            center: initData.initMarker,
            zoom: 13,
            pitch: 65,
            zoomEnable:true,
          });
          addMaker();
        })
        .catch((e) => {
          console.log(e);
        });
    }
    function addMaker() {
      // 用户定位点图标设置 （特殊点）
      let icon = new AMap.Icon({
          size: new AMap.Size(40, 43),    // 图标尺寸
          image: require('@/assets/5101/icon_13.png'),  // Icon的图像
          imageSize: new AMap.Size(40, 43)   // 根据所设置的大小拉伸或压缩图片
      });

      let data = {
        appcode: "5101",
        type: ""
      }
      api("get", "venues", data)
        .then(res => {
          if(res.code === 1200) {
            let markerArr = []
            res.data.forEach(item => {
              let marker = new AMap.Marker({
                  map: initData.map,
                  icon: icon,
                  // position: [item.longitude, item.latitudes],
                  position: new AMap.LngLat(item.gpslon, item.gpslat),
                  offset: new AMap.Pixel(-15, -20)// 弹出框偏移量
              });
              markerArr.push(marker)
              marker.opt = item
              marker.on('click', (e) => {
                let aid = e.target.opt.id;
                let type = e.target.opt.type;

                getInfo(aid, type)
              });
            }) 
            initData.map.add(markerArr)
          }
        })
     
    }
    function getInfo(id, type) {
      initData.loading = true
      api("get", "getVenueInfo", {aid: id, type})
        .then(res => {
          initData.loading = false
          if(res.code === 1200) {
            initData.info = res.data
            initData.dialogVisible = true
          } else {
            ElNotification({
              title: '提示',
              message: res.msg,
              type: 'warning',
            })
          }
        })
        .catch(err => {
          ElNotification({
            title: '提示',
            message: "场馆详情获取失败，请重新尝试！",
            type: 'warning',
          })
        })

    }
    return {
      ...toRefs(initData)
    }
  }
}
</script>

<style lang="less" scoped>
.map {
  height: calc(100vh - 80px);
}
</style>